import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=87c6450a&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=js&"
export * from "./jianyi.vue?vue&type=script&lang=js&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=87c6450a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c6450a",
  null
  
)

export default component.exports